"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : userReactive.js
* Description : Ce fichier contient la définition de la page userReactive 
*               Cette page un message de confirmation pour réactiver un compte utilisateur
* Date de création : 19 janvier 2026
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ /* Hook */ /**
* UserDeactive : affiche un message de confirmation pour réactiver un compte utilisateur
                 un lien permet de revenir à la liste des utilisateurs
*
* Type : page 
*
* Parametres : 
*  None
*/
function UserReactive() {
  //Define useParam
  var _useParams = (0, _reactRouterDom.useParams)(),
    id = _useParams.id;

  // Define useState hooks
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    oldUser = _useState2[0],
    setOldUser = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    statusOldUser = _useState4[0],
    setStatusOldUser = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    statusReactivation = _useState6[0],
    setStatusReactivation = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDataLoading = _useState8[0],
    setDataLoading = _useState8[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken,
    currentUser = _useAuth.currentUser;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path,
    applicationName = _useApi.applicationName;
  var navigate = (0, _reactRouterDom.useNavigate)();

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function sendRequestToReactivate() {
    return _sendRequestToReactivate.apply(this, arguments);
  }
  function _sendRequestToReactivate() {
    _sendRequestToReactivate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, response;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Update User
            _context.n = 1;
            return fetch(path + "/api/au-erus/" + id + "/reactivate/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: ""
            });
          case 1:
            response = _context.v;
            setStatusReactivation(response["status"]);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _sendRequestToReactivate.apply(this, arguments);
  }
  var handleReactive = function handleReactive(event) {
    event.preventDefault();
    sendRequestToReactivate();
  };
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  } // Define useEffect hooks
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var token, response, data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve user details
            _context2.n = 1;
            return fetch(path + "/api/au-erus/" + id + "/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            response = _context2.v;
            _context2.n = 2;
            return response.json();
          case 2:
            data = _context2.v;
            setStatusOldUser(response["status"]);
            setOldUser(data);
            // Dataloading
            setDataLoading(false);
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _retrieveData.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      setDataLoading(true);
      retrieveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    if (statusReactivation === 200) {
      navigate('/users/');
    } else if (statusReactivation !== null) {
      var target_path = '/users/' + id + "/edit";
      navigate(target_path);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusReactivation, navigate]);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [applicationName === "BOXILUMIX" ? currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXILUMIX"
    }) : null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXIBRAIN"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.TabC, {
      tabNumber: 5
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Container, {
        children: isDataLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Chargement des donn\xE9es"
        }) : oldUser ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h1", {
            children: ["Utilisateur ", oldUser["first_name"], " ", oldUser["last_name"]]
          }), Number(oldUser["is_active"]) === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
              children: "Confirmer la r\xE9activation du compte"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "flex-column form-right",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                onClick: handleReactive,
                className: "button",
                children: "Valider"
              })
            })]
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
            children: "Compte d\xE9j\xE0 activ\xE9."
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BackPage, {
            path: '/users/' + id + "/edit",
            children: "Retour"
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          children: ["Utilisateur non disponible ", statusOldUser, " !"]
        })
      })
    })]
  });
}
var _default = exports["default"] = UserReactive;